module.exports = __webpack_public_path__ + "static/media/cube.33260f7c.svg";